var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.className,attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"10"}}),_c('path',{attrs:{"d":"m9 12 2 2 4-4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }